import styled from 'styled-components';
import ChevronLeft from 'assets/chevron-left.svg';
import {injectAdaptive} from 'ui/theme';

export const Container = styled.div`
  position: fixed;
  margin-bottom: 15px;
  padding-left: 21px;
  color: ${(p) => p.theme.light};
  background-image: url('${ChevronLeft}');
  background-repeat: no-repeat;
  background-position: 3px;
  background-size: 14px auto;
  font-size: 14px;
  cursor: pointer;

  ${(p) => injectAdaptive('bottom', p.theme.keyBoardHeightValues)}

  &::after {
    position: absolute;
    top: -35px;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    content: ' ';
  }
`;
